import Vue from "vue";
import Router from "vue-router";

/* Components */
import Login from "@/views/Login";
import Post from "@/views/Post";
import PostCrud from "@/views/PostCrud";
import authentication from "../util/authentication";

Vue.use(Router);

var router = new Router({
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/post",
      name: "Post",
      component: Post
    },
    {
      path: "/post/:id",
      name: "PostCrud",
      component: PostCrud
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  var name = to.name;
  if (authentication.isAdmin()) {
    next();
  } else {
    if (name === "Post" || name === "PostCrud" || name === "Login") {
      next();
    } else {
      next({ name: "Post" });
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js